function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.0007811mm",
    height: "5.9695311mm",
    viewBox: "0 0 4.0007811 5.9695311",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.959825,-96.573439)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 40.821541,100.06406 q -0.01563,0.10938 -0.02344,0.22266 -0.0078,0.10938 -0.0078,0.23438 0,0.63671 0.292969,0.98046 0.296875,0.33985 0.839843,0.33985 0.570313,0 0.902344,-0.34375 0.332031,-0.34375 0.332031,-0.9375 0,-0.51563 -0.28125,-0.789065 -0.28125,-0.273437 -0.808593,-0.273437 -0.386719,0 -0.691407,0.140625 -0.300781,0.136719 -0.554687,0.425777 z m 0.02344,-0.55859 q 0.269532,-0.289062 0.617188,-0.429687 0.351562,-0.144531 0.78125,-0.144531 0.75,0 1.183594,0.433593 0.433593,0.429688 0.433593,1.179685 0,0.83203 -0.554687,1.36719 -0.550781,0.53125 -1.414063,0.53125 -0.878906,0 -1.355468,-0.53906 -0.476563,-0.54297 -0.476563,-1.54297 0,-0.992188 0.410156,-1.839845 0.410157,-0.847656 1.132813,-1.367187 0.3125,-0.222656 0.632812,-0.351563 0.324219,-0.128906 0.546875,-0.128906 0.183594,0 0.273438,0.08203 0.09375,0.07813 0.09375,0.246094 0,0.0625 -0.01172,0.132813 -0.0078,0.07031 -0.03125,0.148437 -0.921875,0.07813 -1.492187,0.636719 -0.570313,0.558594 -0.769532,1.585937 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit6);
export default __webpack_public_path__ + "static/media/digit-6.48b12e532e39edfae45ebb6a9cedbe35.svg";
export { ForwardRef as ReactComponent };